import Premium from "../../public/images/Premium.svg"
import alarm from "../../public/images/alarm.svg"
import app_promo from "../../public/images/app_promo.svg"
import bid_landscape from "../../public/images/bid_landscape.svg"
import watch_list_bar from "../../public/images/watch_list_bar.svg"
import bookmark_blue from "../../public/images/bookmark_blue.svg"
import contract from "../../public/images/contract.svg"
import dashboard from "../../public/images/dashboard.svg"
import diversity_1 from "../../public/images/diversity_1.svg"
import flowsheet from "../../public/images/flowsheet.svg"
import gift_nifty from "../../public/images/Header/gift-nifty-fill.svg"
import live_market from "../../public/images/live_market.svg"
import link_oc from "../../public/images/link_oc.svg"
import lock_reset from "../../public/images/lock_reset.svg"
import logout from "../../public/images/logout.svg"
import model_training from "../../public/images/model_training.svg"
import news from "../../public/images/news.svg"
import newspaper from "../../public/images/Tv_chart_logo.svg"
import person from "../../public/images/person.svg"
import share from "../../public/images/share.svg"
import option_screener_bar from "../../public/images/option_screener_bar.svg"
import table_chart_view_os from "../../public/images/table_chart_view_os.svg"
import advance_stock from "../../public/images/advance_stock.svg"
import stockTracking from "../../public/images/stocks-tracking.svg"
import screener from "../../public/images/Header/screener.svg"
import liveAnalytics from "../../public/images/Header/live_analytices_header.svg"
import marketAction from "../../public/images/Header/market_action.svg"
import contributors from "../../public/images/Header/contributors_header.svg"
import simulator from "../../public/images/Header/simulator.svg"
import intraDay from "../../public/images/Header/bk_intraday.svg"
import trendingOi from "../../public/images/Header/bk_trending.svg"
import multiStrike from "../../public/images/Header/bk_multistrike.svg"
import timeFlow from "../../public/images/Header/bk_timeflow.svg"
import optionChain from "../../public/images/Header/option_chain.svg"
import oiChart from "../../public/images/Header/pcr.svg"
import changeOI from "../../public/images/Header/change_oi.svg"
import pcr from "../../public/images/Header/oi_chart.svg"
import volPcr from "../../public/images/Header/vol_pcr.svg"
import maxPain from "../../public/images/Header/max_pain.svg"
import ipo from "../../public/images/Header/ipo.svg"
import ipo_bar from "../../public/images/ipo_bar.svg"
import stats from "../../public/images/Header/stats.svg"
import dailyStats from "../../public/images/Header/daily_stats.svg"
import broker from "../../public/images/Header/broker.svg"
import calculator from "../../public/images/Header/calculator.svg"
import references from "../../public/images/Header/references.svg"

// label : Upcoming, New, Update

export const analyticsData = [
   {
      title: "SCREENER",
      imageUrl: screener,
      description: null,
      items: [
         {
            title: "Advanced Stock Screener",
            description: "EOD research and analysis",
            label: null,
            pageUrl: "/advanced-stock-screener?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Live Market Screener",
            description: "Real time stocks filter",
            label: null,
            pageUrl: "/stock-screener?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Options Screener",
            description: "Real time filter for FnO stocks",
            label: null,
            pageUrl: "/options-screener?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
   {
      title: "LIVE ANALYTICS",
      tag: "Prime",
      description:
         "Real time Market Trend, Central pivot range and detail information for Indices and stocks.",
      imageUrl: liveAnalytics,
      items: [
         {
            title: "Nifty Live Analytics",
            description: null,
            label: null,
            pageUrl: "/live-analytics?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Bank Nifty Live Analytics",
            description: null,
            label: null,
            pageUrl: "/banknifty-live-analysis?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Finnifty Live Analytics",
            description: null,
            label: null,
            pageUrl: "/finnifty-live-analysis?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Midcap Nifty Live Analytics",
            description: null,
            label: null,
            pageUrl: "/midcpnifty-live-analysis?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Sensex Today",
            description: null,
            label: null,
            pageUrl: "/sensex-today?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
   {
      title: "MARKET ACTION",
      imageUrl: marketAction,
      items: [
         {
            title: "Opening Price Clues",
            description: null,
            label: null,
            pageUrl: "/opening-price-clues?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Gap Up, Gap Down",
            description: null,
            label: null,
            pageUrl: "/gap-ups-gap-downs?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Breakout Stocks",
            description: null,
            label: null,
            pageUrl: "/nse-stocks-price?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Gainers & Losers",
            description: null,
            label: null,
            pageUrl: "/nse-top-gainers?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Volume Shockers",
            description: null,
            label: null,
            pageUrl: "/nse-stocks-volume?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Advance Decline Ratio Chart",
            description: null,
            label: null,
            pageUrl: "/advance-decline-ratio?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
   {
      title: "STOCK TRACKING",
      imageUrl: stockTracking,
      items: [
         {
            title: "GPT Alerts and Watchlist",
            description: null,
            label: null,
            pageUrl: "/watchlist?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "TV Chart",
            description: null,
            label: null,
            pageUrl: "/share-price-chart/nifty-50?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Custom Alerts",
            description: null,
            label: null,
            pageUrl: "/stockalerts?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Derivative Summary",
            description: null,
            label: null,
            pageUrl: "/derivative-summary?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         // {
         //    title: "F&O Signals",
         //    description: null,
         //    label: 'Upcoming',
         //    pageUrl: "",
         // },
         {
            title: "Stock Futures",
            description: null,
            label: null,
            pageUrl: "/stock-futures?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Sector Analysis",
            description: null,
            label: null,
            pageUrl: "/sector-analysis?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
   {
      title: "CONTRIBUTORS",
      description: "Keep Track of Real time trend of NSE/BSE indices contributors",
      imageUrl: contributors,
      items: [
         {
            title: "Nifty 50 Contributors",
            description: null,
            label: null,
            pageUrl: "/nifty50-contributors?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Nifty Next 50 Contributors",
            description: null,
            label: null,
            pageUrl: "/nifty-next50-contributors?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Bank Nifty Contributors",
            description: null,
            label: null,
            pageUrl: "/nifty-bank-contributors?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Finnifty Contributors",
            description: null,
            label: null,
            pageUrl: "/nifty-fin-contributors?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Midcap Nifty Contributors",
            description: null,
            label: null,
            pageUrl: "/midcap-nifty-contributors?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Midcap Select Contributors",
            description: null,
            label: null,
            pageUrl: "/midcap-select-contributors?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "BSE Sensex Contributors",
            description: null,
            label: null,
            pageUrl: "/sensex-contributor?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
]

export const backTestingData = [
   {
      title: "OPTION SIMULATOR",
      imageUrl: simulator,
      description: "Back Test, model and analyze the potential outcomes of trading strategies along with pre built",
      items: [
         {
            title: "Nifty Option Simulator",
            description: null,
            label: null,
            pageUrl: "/options-simulator/nifty?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Bank Nifty Option Simulator",
            description: null,
            label: null,
            pageUrl: "/options-simulator/banknifty?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Finnifty Option Simulator",
            description: null,
            label: null,
            pageUrl: "/options-simulator/finnifty?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
   {
      title: "INTRADAY BACKTEST",
      imageUrl: intraDay,
      tag: "Prime",
      description:
         "Back Test and model all your Intraday Trade strategies with our pre built strategies ",
      items: [
         {
            title: "Nifty Options",
            description: null,
            label: null,
            pageUrl: "/options-trading-backtesting/nifty?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Bank Nifty Options",
            description: null,
            label: null,
            pageUrl: "/options-trading-backtesting/banknifty?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Finnifty Options",
            description: null,
            label: null,
            pageUrl: "/options-trading-backtesting/finnifty?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Midcap Nifty Options",
            description: null,
            label: null,
            pageUrl: "/options-trading-backtesting/midcpnifty?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
   {
      title: "TRENDING OI",
      imageUrl: trendingOi,
      tag: "Prime",
      description:
         "Check the calculated change of direction of market and accurate sentiment analysis of intraday market",
      items: [
         {
            title: "NSE Trending OI",
            description: null,
            label: null,
            pageUrl: "/nifty-trending-oi?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "BSE Trending OI",
            description: null,
            label: null,
            pageUrl: "/sensex-trending-oi?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "NSE Commodity Trending OI",
            description: null,
            label: null,
            pageUrl: "/mcx-trending-oi?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
   {
      title: "MULTI STRIKE COMPARISON",
      imageUrl: multiStrike,
      description:
         "Get the Call and Put OI, Vol, PCR, LTP , change in OI comparison chart on more strikes.",
      items: [
         {
            title: "Nifty",
            description: null,
            label: null,
            pageUrl: "/nifty-multi-strike-comparison?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Bank Nifty",
            description: null,
            label: null,
            pageUrl: "/banknifty-multi-strike-comparison?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Finnifty",
            description: null,
            label: null,
            pageUrl: "/finnifty-multi-strike-comparison?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Nifty Midcap Select",
            description: null,
            label: null,
            pageUrl: "/midcpnifty-multi-strike-comparison?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
   {
      title: "OI TIMEFLOW",
      imageUrl: timeFlow,
      description:
         "Check the Intraday Option chain and get the complete day's LTP calculation at one step.",
      items: [
         {
            title: "Nifty OI Timeflow",
            description: null,
            label: null,
            pageUrl: "/ltp-calculator/nifty?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Bank Nifty OI Timeflow",
            description: null,
            label: null,
            pageUrl: "/ltp-calculator/banknifty?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Finnifty OI Timeflow",
            description: null,
            label: null,
            pageUrl: "/ltp-calculator/finnifty?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Midcap Nifty OI Timeflow",
            description: null,
            label: null,
            pageUrl: "/ltp-calculator/midcpnifty?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Sensex OI Timeflow",
            description: null,
            label: null,
            pageUrl: "/ltp-calculator/sensex?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "NSE Commodity OI Timeflow",
            description: null,
            label: null,
            pageUrl: "/mcx-ltp-calculator?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
]

export const optionsData = [
   {
      title: "OPTION CHAIN",
      imageUrl: optionChain,
      description: "Get Technical study & Download Greeks of Option Chain with live quotes",
      items: [
         {
            title: "NSE Option Chain",
            description: null,
            label: null,
            pageUrl: "/nse-option-chain?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "BSE Option Chain",
            description: null,
            label: null,
            pageUrl: "/bse-option-chain?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "NSE Commodity Option Chain",
            description: null,
            label: null,
            pageUrl: "/commodities-option-chain-nse?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
   {
      title: "OI CHART",
      imageUrl: oiChart,
      tag: "Prime",
      description: "Get line chart and bar chart view for all indices and F&O stocks open interest",
      items: [
         {title: "Nifty", description: null, label: null, pageUrl: "/live-nifty-open-interest"},
         {
            title: "Bank Nifty",
            description: null,
            label: null,
            pageUrl: "/banknifty-live-oi-tracker?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Finnifty",
            description: null,
            label: null,
            pageUrl: "/live-finnifty-open-interest?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Midcap Nifty",
            description: null,
            label: null,
            pageUrl: "/live-midcpnifty-open-interest?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Sensex",
            description: null,
            label: null,
            pageUrl: "/live-sensex-open-interest?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Stocks",
            description: null,
            label: null,
            pageUrl: "/stock-options-chart/sbin?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
   {
      title: "CHANGE IN OI",
      imageUrl: changeOI,
      description:
         "Get line chart and bar chart view for all indices and F&O stocks change in OI",
      items: [
         {
            title: "Nifty",
            description: null,
            label: null,
            pageUrl: "/nifty-live-change-in-oi?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Bank Nifty",
            description: null,
            label: null,
            pageUrl: "/bank-nifty-live-oi-change?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Finnifty",
            description: null,
            label: null,
            pageUrl: "/finnifty-live-change-in-oi?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Midcap Nifty",
            description: null,
            label: null,
            pageUrl: "/midcpnifty-live-change-in-oi?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Sensex",
            description: null,
            label: null,
            pageUrl: "/sensex-live-change-in-oi?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Stocks",
            description: null,
            label: null,
            pageUrl: "/stock-options-chart/sbin?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
   {
      title: "PCR",
      imageUrl: pcr,
      description: "Get updated Put call ratio(PCR) charts of all Indices and F&O stocks",
      items: [
         {
            title: "Nifty",
            description: null,
            label: null,
            pageUrl: "/nifty-put-call-ratio?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Bank Nifty",
            description: null,
            label: null,
            pageUrl: "/banknifty-intra-pcr-trend?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Finnifty",
            description: null,
            label: null,
            pageUrl: "/finnifty-put-call-ratio?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Midcap Nifty",
            description: null,
            label: null,
            pageUrl: "/midcpnifty-put-call-ratio?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {title: "Sensex", description: null, label: null, pageUrl: "/sensex-put-call-ratio?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track"},
         {title: "Stocks", description: null, label: null, pageUrl: "/stock-options-chart/sbin?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track"},
      ],
   },
   {
      title: "VOLUME PCR",
      imageUrl: volPcr,
      tag: "Prime",
      description: "Get updated Volume Put call ratio(PCR) charts of all Indices and F&O stocks",
      items: [
         {
            title: "Nifty",
            description: null,
            label: null,
            pageUrl: "/nifty-put-call-ratio-volume?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Bank Nifty",
            description: null,
            label: null,
            pageUrl: "/banknifty-intra-volume-pcr-trend?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Finnifty",
            description: null,
            label: null,
            pageUrl: "/finnifty-put-call-ratio-volume?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Midcap Nifty",
            description: null,
            label: null,
            pageUrl: "/midcpnifty-put-call-ratio-volume?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Sensex",
            description: null,
            label: null,
            pageUrl: '/sensex-put-call-ratio-volume?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track',
         },
         {
            title: "Stocks",
            description: null,
            label: null,
            pageUrl: "/stock-options-chart/sbin?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
   {
      title: "LIVE MAX PAIN",
      imageUrl: maxPain,
      description: "Get Live max pain chart of all indices and F&O stocks, Sensex",
      items: [
         {
            title: "Nifty",
            description: null,
            label: null,
            pageUrl: "/options-max-pain-chart-live/nifty?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Bank Nifty",
            description: null,
            label: null,
            pageUrl: "/options-max-pain-chart-live/banknifty?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Finnifty",
            description: null,
            label: null,
            pageUrl: "/options-max-pain-chart-live/finnifty?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Midcap Nifty",
            description: null,
            label: null,
            pageUrl: "/options-max-pain-chart-live/midcpnifty?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Sensex",
            description: null,
            label: null,
            pageUrl: "/bse-options-max-pain-chart-live?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Stocks",
            description: null,
            label: null,
            pageUrl: "/options-max-pain-chart-live/sbin?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
]

export const resourcesData = [
   {
      title: "IPO",
      imageUrl: ipo,
      description: null,
      tag: null,
      items: [
         {
            title: "Upcoming IPO",
            description: null,
            label: null,
            pageUrl: "/ipo/upcoming?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Current IPO",
            description: null,
            label: null,
            pageUrl: "/ipo/ongoing?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Closed IPO",
            description: null,
            label: null,
            pageUrl: "/ipo/closed?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Recently Listed IPO",
            description: null,
            label: null,
            pageUrl: "/ipo/new-listed?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "SME IPO",
            description: null,
            label: null,
            pageUrl: "/ipo/sme?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Mainboard IPO",
            description: null,
            label: null,
            pageUrl: "/ipo/main-board?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
   {
      title: "STATS",
      imageUrl: stats,
      description: null,
      tag: null,
      items: [
         {
            title: "F&O Lot Size",
            description: null,
            label: null,
            pageUrl: "/nse-fo-lot-size?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Result Calendar",
            description: null,
            label: null,
            pageUrl: "/results-calendar?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Bulk Deals",
            description: null,
            label: null,
            pageUrl: "/bulk-deals-data?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
   {
      title: "DAILY STATS",
      imageUrl: dailyStats,
      description: null,
      tag: null,
      items: [
         {
            title: "FII DII Data",
            description: null,
            label: null,
            pageUrl: "/fii-dii-data?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Participant Wise OI",
            description: null,
            label: null,
            pageUrl: "/participant-wise-oi?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "F&O of FII",
            description: null,
            label: null,
            pageUrl: "/fii-dii-data?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Ban List",
            description: null,
            label: null,
            pageUrl: "/ban-list?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "BSE NSE Holiday List",
            description: null,
            label: null,
            pageUrl: "/bse-nse-trading-holidays?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Commodity Trading Holiday",
            description: null,
            label: null,
            pageUrl: "/commodity-trading-holidays?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
   {
      title: "BROKERS",
      imageUrl: broker,
      description: null,
      tag: null,
      items: [
         {
            title: "Broker Directory",
            description: null,
            label: null,
            pageUrl: "/broker-directory?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Compare Broker",
            description: null,
            label: null,
            pageUrl: "/select-best-broker?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Stock Broker in India",
            description: null,
            label: null,
            pageUrl: "/stock-brokers-in-india?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
   {
      title: "CALCULATOR",
      imageUrl: calculator,
      description: null,
      tag: null,
      items: [
         {
            title: "Option Pricing Calculator",
            description: null,
            label: null,
            pageUrl: "/option-pricing-calculator?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Fibonacci Calculator",
            description: null,
            label: null,
            pageUrl: "/fibonacci-calculator?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Pivot Calculator",
            description: null,
            label: null,
            pageUrl: "/pivot-calculator?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Developing Pivot Calculator",
            description: null,
            label: null,
            pageUrl: "/developing-pivots?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Elliot Wave Fibonacci Cluster Calculator",
            description: null,
            label: null,
            pageUrl: "/elliott-wave-fibonacci-cluster-calculator?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
   {
      title: "REFERENCES",
      imageUrl: references,
      description: null,
      tag: null,
      items: [
         // {
         //    title: "Trading & Investment Terminology",
         //    description: null,
         //    label: null,
         //    pageUrl: "/terms",
         // },
         {
            title: "Option Strategies to Mint Money",
            description: null,
            label: null,
            pageUrl: "/option-strategies?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Candlestick Pattern",
            description: null,
            label: null,
            pageUrl: "/candlestick-patterns?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
         {
            title: "Investing Books",
            description: null,
            label: null,
            pageUrl: "/investing-books?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
         },
      ],
   },
]

// menu data
export const barsMenuData = [
   {
      label: "Advanced Stock Screener",
      icon: advance_stock,
      pageUrl: "/advanced-stock-screener?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
      bg: "#F1FFF1",
   },
   {
      label: "Live Market Screener",
      icon: live_market,
      bg: "#FFEAEA",
      pageUrl: "/stock-screener?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },
   {
      label: "Options Screener",
      icon: option_screener_bar,
      bg: "#ECF5FE",
      pageUrl: "/options-screener?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },
   {
      label: "NSE Option Chain",
      icon: link_oc,
      bg: "#F3E8FF",
      pageUrl: "/nse-option-chain?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },
   {
      label: "BSE Option Chain",
      icon: flowsheet,
      bg: "#FFEFFC",
      pageUrl: "/bse-option-chain?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },

   {
      label: "Stock Analysis",
      icon: bid_landscape,
      bg: "#FFF6E4",
      pageUrl: "/stocks-analysis?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },

   {
      label: "GPT Watchlist",
      icon: watch_list_bar,
      bg: "#E7FAFF",
      pageUrl: "/watchlist?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },
   {
      label: "GIFT NIFTY",
      icon: gift_nifty,
      bg: "#FFECE4",
      pageUrl: "/gift-nifty-live?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },
   // {
   //    label: "News",
   //    icon: newspaper,
   //    bg: "#FFEAEA",
   //    pageUrl: "/news",
   // },    pageUrl: "/share-price-chart/NIFTY%2050",

{
      label: "TV Chart",
      icon: newspaper,
      bg: "#333333",
      pageUrl: "/share-price-chart/nifty-50?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },

   {
      label: "IPO",
      icon: ipo_bar,
      bg: "#ECF5FE",
      pageUrl: "/ipo?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },
   {
      label: "Strategy Builder",
      icon: model_training,
      bg: "#F3E8FF",
      pageUrl: "/option-strategy-builder?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },
   {
      label: "Options Simulator",
      icon: table_chart_view_os,
      bg: "#FFEFFC",
      pageUrl: "/options-simulator/nifty?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },
   {
      label: "Prime",
      icon: Premium,
      bg: "#FFF6E4",
      pageUrl: "/primeplans?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },
   {
      label: "Blog",
      icon: news,
      bg: "#E7FAFF",
      pageUrl: "/content/?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },
]

// profile data
export const profileData = [
   {
      label: "My Profile",
      icon: person,
      pageUrl: "/my-profile?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },
   {
      label: "My Dashboard",
      icon: dashboard,
      pageUrl: "/my-dashboard?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },
   {
      label: "My Watchlist",
      icon: bookmark_blue,
      pageUrl: "/watchlist?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },
   {
      label: "My Alerts",
      icon: alarm,
      pageUrl: "/stockalerts?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },
   {
      label: "My Portfolio",
      icon: contract,
      pageUrl: "/portfolio?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },
   {
      label: "Share a Trial",
      icon: share,
      pageUrl: "/share-a-trial?utm_source=Menu&utm_medium=Header-Dropdown&utm_campaign=Click-Track",
   },
   {
      label: "Social Media",
      icon: diversity_1,
      pageUrl: "",
   },
   {
      label: "Change Password",
      icon: lock_reset,
      pageUrl: "",
   },
   {
      label: "Download App",
      icon: app_promo,
      pageUrl: "",
   },
   {
      label: "Logout",
      icon: logout,
      pageUrl: "",
   },
]

export const allPages = [
   {
      pageName: "Bank Nifty Share Price ",
      pageUrl: "https://www.niftytrader.in/bank-nifty-share-price",
   },
   {
      pageName: "Upcoming IPO",
      pageUrl: "https://niftytrader.in/ipo/upcoming",
   },
   {
      pageName: "IPO Calendar",
      pageUrl: "https://niftytrader.in/ipo/calendar",
   },
   {
      pageName: "Current IPO",
      pageUrl: "https://niftytrader.in/ipo/ongoing",
   },
   {
      pageName: "Closed IPO",
      pageUrl: "https://niftytrader.in/ipo/closed",
   },
   {
      pageName: "Stock Market News",
      pageUrl: "https://www.niftytrader.in/content/stock-market-news/",
   },
   {
      pageName: "Fixed Deposit",
      pageUrl: "https://www.niftytrader.in/fixed-deposit",
   },
   {
      pageName: "FD Interest Rates",
      pageUrl: "https://www.niftytrader.in/fd-interest",
   },
   {
      pageName: "FD Calculator",
      pageUrl: "https://www.niftytrader.in/fd-calculator",
   },
   {
      pageName: "Nifty Share Price",
      pageUrl: "https://www.niftytrader.in/nifty-share-price",
   },
   {
      pageName: "Sensex Today",
      pageUrl: "https://www.niftytrader.in/sensex-today",
   },
   {
      pageName: "Advanced Stock Screener",
      pageUrl: "https://www.niftytrader.in/advanced-stock-screener",
   },
   {
      pageName: "Live Market Screener",
      pageUrl: "https://www.niftytrader.in/live-market-screener",
   },
   {
      pageName: "Options Screener",
      pageUrl: "https://www.niftytrader.in/options-screener",
   },
   {
      pageName: "Nifty Open Interest",
      pageUrl: "https://www.niftytrader.in/live-nifty-open-interest",
   },
   {
      pageName: "Nifty Change in Open Interest",
      pageUrl: "https://www.niftytrader.in/nifty-live-change-in-oi",
   },
   {
      pageName: "Nifty Option Chain Put Call Ratio",
      pageUrl: "https://www.niftytrader.in/nifty-put-call-ratio",
   },
   {
      pageName: "Nifty Option Chain Put Call Ratio Volume",
      pageUrl: "https://www.niftytrader.in/nifty-put-call-ratio-volume",
   },
   {pageName: "Nifty Live Analytics", pageUrl: "https://www.niftytrader.in/live-analytics"},
   {
      pageName: "Nifty Multi Strike Comparison",
      pageUrl: "https://www.niftytrader.in/nifty-multi-strike-comparison",
   },
   {
      pageName: "Nifty Trending OI",
      pageUrl: "https://www.niftytrader.in/nifty-trending-oi",
      badge: "New",
   },
   {pageName: "Stock Option Chart", pageUrl: "https://www.niftytrader.in/stock-options-chart/sbin"},
   {
      pageName: "NSE Commodity Option Chain",
      pageUrl: "https://www.niftytrader.in/commodities-option-chain-nse",
      badge: "New",
   },
   {
      pageName: "BSE Option Chain",
      pageUrl: "https://www.niftytrader.in/bse-option-chain",
      badge: "Updated",
   },
   {
      pageName: "Live Max Pain Chart for Derivative Stocks",
      pageUrl: "https://www.niftytrader.in/options-max-pain-chart-live/sbin",
   },
   {
      pageName: "Option Strategies to Mint Money",
      pageUrl: "https://www.niftytrader.in/option-strategies",
   },
   {
      pageName: "LTP OI Timeflow",
      pageUrl: "https://www.niftytrader.in/ltp-calculator",
      badge: "New",
   },
   {pageName: "Option Strategy Builder", pageUrl: "https://www.niftytrader.in/option-strategy-builder"},
   {pageName: "Options Simulator", pageUrl: "https://www.niftytrader.in/options-simulator"},
   {
      pageName: "Bank Nifty Open Interest Live Chart",
      pageUrl: "https://www.niftytrader.in/banknifty-live-oi-tracker",
   },
   {
      pageName: "Bank Nifty Change in Open Interest",
      pageUrl: "https://www.niftytrader.in/bank-nifty-live-oi-change",
   },
   {
      pageName: "Bank Nifty PCR Live Chart",
      pageUrl: "https://www.niftytrader.in/banknifty-intra-pcr-trend",
   },
   {
      pageName: "Bank Nifty Volume PCR Live Chart",
      pageUrl: "https://www.niftytrader.in/banknifty-intra-volume-pcr-trend",
   },
   {
      pageName: "Bank Nifty Live Analytics",
      pageUrl: "https://www.niftytrader.in/banknifty-live-analysis",
   },
   {
      pageName: "Bank Nifty Multi Strike Comparison",
      pageUrl: "https://www.niftytrader.in/banknifty-multi-strike-comparison",
   },
   {
      pageName: "Bank Nifty Trending OI",
      pageUrl: "https://www.niftytrader.in/banknifty-trending-oi",
      badge: "New",
   },
   {
      pageName: "Fin Nifty Open Interest Tracker",
      pageUrl: "https://www.niftytrader.in/live-finnifty-open-interest",
   },
   {
      pageName: "Fin Nifty Change in Open Interest",
      pageUrl: "https://www.niftytrader.in/finnifty-live-change-in-oi",
   },
   {
      pageName: "Fin Nifty Option Chain Put Call Ratio",
      pageUrl: "https://www.niftytrader.in/finnifty-put-call-ratio",
   },
   {
      pageName: "Fin Nifty Option Chain Put Call Ratio Volume",
      pageUrl: "https://www.niftytrader.in/finnifty-put-call-ratio-volume",
   },
   {
      pageName: "Fin Nifty Live Analytics",
      pageUrl: "https://www.niftytrader.in/finnifty-live-analysis",
   },
   {
      pageName: "Fin Nifty Multi Strike Comparison",
      pageUrl: "https://www.niftytrader.in/finnifty-multi-strike-comparison",
   },
   {
      pageName: "Fin Nifty Trending OI",
      pageUrl: "https://www.niftytrader.in/finnifty-trending-oi",
      badge: "New",
   },
   {
      pageName: "Nifty Midcap Select Open Interest",
      pageUrl: "https://www.niftytrader.in/live-midcpnifty-open-interest",
   },
   {
      pageName: "Nifty Midcap Select Change in Open Interest",
      pageUrl: "https://www.niftytrader.in/midcpnifty-live-change-in-oi",
   },
   {
      pageName: "Nifty Midcap Select Option Chain Put Call Ratio",
      pageUrl: "https://www.niftytrader.in/midcpnifty-put-call-ratio",
   },
   {
      pageName: "Nifty Midcap Select Option Chain Put Call Ratio Volume",
      pageUrl: "https://www.niftytrader.in/midcpnifty-put-call-ratio-volume",
   },
   {
      pageName: "Nifty Midcap Select Live Analytics",
      pageUrl: "https://www.niftytrader.in/midcpnifty-live-analysis",
   },
   {
      pageName: "Nifty Midcap Select Multi Strike Comparison",
      pageUrl: "https://www.niftytrader.in/midcpnifty-multi-strike-comparison",
   },
   {
      pageName: "Nifty Midcap Select Trending OI",
      pageUrl: "https://www.niftytrader.in/midcpnifty-trending-oi",
   },
   {pageName: "Trading and Investment Terminology", pageUrl: "https://www.niftytrader.in/terms"},
   {pageName: "Investing Books", pageUrl: "https://www.niftytrader.in/investing-books"},
   {pageName: "Candlestick Patterns", pageUrl: "https://www.niftytrader.in/candlestick-patterns"},
   {pageName: "Broker Directory", pageUrl: "https://www.niftytrader.in/broker-directory"},
   {pageName: "Compare Brokers", pageUrl: "https://www.niftytrader.in/select-best-broker"},
   {
      pageName: "Stock Brokers in India",
      pageUrl: "https://www.niftytrader.in/stock-brokers-in-india",
   },
   {pageName: "Volume Shockers", pageUrl: "https://www.niftytrader.in/nse-stocks-volume"},
   {pageName: "Intraday Breakouts", pageUrl: "https://www.niftytrader.in/nse-stocks-price"},
   {pageName: "Gap Up, Gap Down Stocks", pageUrl: "https://www.niftytrader.in/gap-ups-gap-downs"},
   {pageName: "Opening Price Clues", pageUrl: "https://www.niftytrader.in/opening-price-clues"},
   {pageName: "Top Gainer Stocks", pageUrl: "https://www.niftytrader.in/nse-top-gainers"},
   {pageName: "Top Loser Stocks", pageUrl: "https://www.niftytrader.in/nse-top-losers"},
   {
      pageName: "Option Pricing Calculator",
      pageUrl: "https://www.niftytrader.in/option-pricing-calculator",
   },
   {pageName: "Fibonacci Calculator", pageUrl: "https://www.niftytrader.in/fibonacci-calculator"},
   {pageName: "Pivot Calculator", pageUrl: "https://www.niftytrader.in/pivot-calculator"},
   {
      pageName: "Developing Pivot Calculator",
      pageUrl: "https://www.niftytrader.in/developing-pivots",
   },
   {
      pageName: "Elliot Wave Fibonacci Cluster Calculator",
      pageUrl: "https://www.niftytrader.in/elliott-wave-fibonacci-cluster-calculator",
   },
   {pageName: "FII Data F&O & cash", pageUrl: "https://www.niftytrader.in/fii-dii-data"},
   {pageName: "FII DII Data", pageUrl: "https://www.niftytrader.in/fii-dii-data"},
   {
      pageName: "NSE F&O Lot Size | NiftyTrader",
      pageUrl: "https://www.niftytrader.in/nse-fo-lot-size",
   },
   {
      pageName: "BSE NSE Holidays List",
      pageUrl: "https://www.niftytrader.in/bse-nse-trading-holidays",
   },
   {
      pageName: "Commodity Trading Holidays",
      pageUrl: "https://www.niftytrader.in/commodity-trading-holidays",
   },
   {pageName: "Participant Wise OI", pageUrl: "https://www.niftytrader.in/participant-wise-oi"},
   {pageName: "NSE Bulk Deals Data", pageUrl: "https://www.niftytrader.in/bulk-deals-data"},
   {pageName: "Ban List", pageUrl: "https://www.niftytrader.in/ban-list"},
   {pageName: "Derivative Summary", pageUrl: "https://www.niftytrader.in/derivative-summary"},
   {pageName: "Stock Futures", pageUrl: "https://www.niftytrader.in/stock-futures/nifty"},
   {
      pageName: "Nifty 50 Contributors",
      pageUrl: "https://www.niftytrader.in/nifty50-contributors",
   },
   {
      pageName: "Nifty Next 50 Contributors",
      pageUrl: "https://www.niftytrader.in/nifty-next50-contributors",
   },
   {
      pageName: "Bank Nifty Contributors",
      pageUrl: "https://www.niftytrader.in/nifty-bank-contributors",
   },
   {
      pageName: "Fin Nifty Contributors",
      pageUrl: "https://www.niftytrader.in/nifty-fin-contributors",
   },
   {
      pageName: "Midcap Nifty Contributors",
      pageUrl: "https://www.niftytrader.in/midcap-nifty-contributors",
   },
   {
      pageName: "Midcap Select Contributors",
      pageUrl: "https://www.niftytrader.in/midcap-select-contributors",
   },
   {
      pageName: "Nifty Live Analytics",
      pageUrl: "https://www.niftytrader.in/live-analytics",
   },
   {
      pageName: "Bank Nifty Analytics",
      pageUrl: "https://www.niftytrader.in/banknifty-live-analysis",
   },
   {
      pageName: "Fin Nifty Analytics",
      pageUrl: "https://www.niftytrader.in/finnifty-live-analysis",
   },
   {
      pageName: "NSE Option Chain",
      pageUrl: "https://www.niftytrader.in/nse-option-chain",
   },

   {
      pageName: "Stock Analysis",
      pageUrl: "https://www.niftytrader.in/stocks-analysis",
   },

   {
      pageName: "GPT Watchlist",
      pageUrl: "https://www.niftytrader.in/watchlist",
   },
   {
      pageName: "GIFT NIFTY",
      pageUrl: "https://www.niftytrader.in/gift-nifty-live",
   },
   {
      pageName: "News",
      pageUrl: "https://www.niftytrader.in/content/stock-market-news/",
   },

   {
      pageName: "IPO",
      pageUrl: "https://www.niftytrader.in/ipo",
   },
   {
      pageName: "Prime",
      pageUrl: "https://www.niftytrader.in/primeplans",
   },
   {
      pageName: "Blog",
      pageUrl: "https://www.niftytrader.in/content/",
   },
   {
      pageName: "My Profile",
      pageUrl: "https://www.niftytrader.in/my-profile",
   },
   {
      pageName: "My Dashboard",
      pageUrl: "https://www.niftytrader.in/my-dashboard",
   },
   {
      pageName: "My Watchlist",
      pageUrl: "https://www.niftytrader.in/watchlist",
   },
   {
      pageName: "My Alerts",
      pageUrl: "https://www.niftytrader.in/stockalerts",
   },
   {
      pageName: "My Portfolio",
      pageUrl: "https://www.niftytrader.in/portfolio",
   },
   {
      pageName: "Share a Trial",
      pageUrl: "https://www.niftytrader.in/share-a-trial",
   },
   {
      pageName: "Gold Price Today",
      pageUrl: "https://www.niftytrader.in/gold-price-today",
   },
   {
      pageName: "Silver Rate Today",
      pageUrl: "https://www.niftytrader.in/silver-rate-today",
   },
   {
      pageName: "India Vix",
      pageUrl: "https://www.niftytrader.in/india-vix",
   },
   {
      pageName: "Advance-Decline-Ratio",
      pageUrl: "https://www.niftytrader.in/advance-decline-ratio",
   },
   {
      pageName: "Nifty Option Chain",
      pageUrl: "https://www.niftytrader.in/nse-option-chain/nifty",
   },
   {
      pageName: "Sensex Option Chain",
      pageUrl: "https://www.niftytrader.in/bse-option-chain/sensex",
   },
   {
      pageName: "Nifty 50",
      pageUrl: "https://www.niftytrader.in/share-price-chart/nifty-50",
   },
]